import React, { useState, useEffect, forwardRef } from   'react';
import { useParams, useNavigate} from 'react-router-dom';
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import { useAuth } from '../../Auth/AuthContext';
import apiService from './../../Auth/apiService';
import { useForm, Controller } from 'react-hook-form';
import { FaCalendar } from 'react-icons/fa';
import moment from 'moment';
import { getMunicipiosDX, saveMunicipiosDX } from '../Utils/indexedDBUtils';

const hechos = [
    { value: 'DESAPARICION', label: 'Desaparición forzada' },
    { value: 'SECUESTRO', label: 'Secuestro' },
    { value: 'DESPLAZAMIENTO', label: 'Desplazamiento forzado' },
    { value: 'HOMICIDIO', label: 'Homicidio' },
    { value: 'MASACRE', label: 'Masacre' },
    { value: 'TORTURA', label: 'Tortura o tratos inhumanos degradantes' },
    { value: 'LESIONES PERSONALES', label: 'Lesiones Personales Permanentes o Transitorias' },
    { value: 'MINAS ANTIPERSONA', label: 'Minas antipersonal, Municiones sin Explotar, y Artefacto Explosivo improvisado' },
    { value: 'DELITOS Y VIOLENCIA SEXUAL', label: 'Delitos contra la libertad y la integridad sexual' },
    { value: 'RECLUTAMIENTO', label: 'Reclutamiento y utilización' },
    { value: 'INTENTO RECLUTAMIENTO', label: 'Intento de Reclutamiento' },
    { value: 'ACTO TERRORISTA', label: 'Acto terrorista/Atentados/Combates/Enfrentamientos/Hostigamientos' },
    { value: 'AMENAZA', label: 'Amenaza' },
    { value: 'DESPOJO', label: 'Despojo y abandono forzado de tierras' },
];

const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick(e);
                }
            }}
            ref={ref}
            aria-label="Abrir selector de fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none' }}/>
            <FaCalendar/>
        </button>
    ));

export default function DXVictimizacion() {
    const { iddx } = useParams();
    const { idrecepcion } = useParams();
    const { token } = useAuth();
    const Navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [Cargando, setCargando] = useState(false)
    const [actoresarmados, setActoresarmados] = useState([]);
    const [enfoquegeneros, setEnfoquegeneros] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [estadoDx, setEstadoDx] = useState('');
    const [entidadesdeclaracion, setEntidadesdeclaracion] = useState([]);
    const [tiposdesplazamiento, setTiposdesplazamiento] = useState([]);
    const [lugaresexpulsores, setLugaresexpulsores] = useState([]);
    const [tiposmovilidades, setTiposmovilidades] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [departamentosExpulsor, setDepartamentosExpulsor] = useState([]);
    const [municipiosExpulsor, setMunicipiosExpulsor] = useState([]);
    const [pendingResetData, setPendingResetData] = useState(null);
    const [cualeshechos, setCualeshechos] = useState([]);
    const [cualeshechosSeleccionadas, setCualeshechosSeleccionadas] = useState([]);
    const [cualeshechosdeclarados, setCualeshechosdeclarados] = useState([]);
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const [cualeshechosdeclaradosSeleccionadas, setCualeshechosdeclaradosSeleccionadas] = useState([]);
    const { watch, handleSubmit, register, setValue, reset, control, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
                vict_4_1_14_a_m_donde_realizo_declaracion: '',
                codigoFUD: '',
                vict_4_1_15_1_hecho_no_declarado_cual: '',
                vict_4_1_16_tipo_desplazamiento: '',
                vict_4_2_actor_armado_ocasiono_el_hecho_victimizante: '',
                vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante: '',
                vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar: '',
                vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer: '',
                vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad: '',
                vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual: '',
                vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad: '',
                vict_4_3_3_1_identifico_violencia_basada_en_genero: '',
                vict_4_3_3_2_identifico_violencia_basada_en_genero: '',
                vict_4_3_3_3_identifico_violencia_basada_en_genero: '',
                vict_4_4_1_departamento: '',
                vict_4_4_2_municipio: '',
                vict_4_4_3_subregion_antioquia: 'N/A',
                vict_4_4_4_lugar_exacto_del_municipio: '',
                vict_4_4_5_nombre_tipo_entorno: '',
                vict_4_4_6_tipo_movilidad: '',
                vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento: '',
                vict_4_4_8_hecho_intraurbano_barrio: '',
                vict_4_4_9_hecho_intraurbano_sector_o_asentamiento: '',
                vict_4_4_10_hecho_intraurbano_direccion: '',
                vict_4_5_fecha_hecho: '',
                vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho: '',
                vict_4_7_observaciones: '',
            } 
        }
    );
    
    const ActualizarCualesHechos = hecho => {
        setCualeshechosSeleccionadas(hecho);
    };
    const ActualizarCualesHechosDeclarados = hecho => {
        setCualeshechosdeclaradosSeleccionadas(hecho);
    };
    
    async function getMunicipiosDXData() {
        const cachedmunicipiosDX = await getMunicipiosDX();
        if (cachedmunicipiosDX) {
            setMunicipios(cachedmunicipiosDX);
        } else {
            // If not in IndexedDB, fetch from the API
            const municipios = await fetchMunicipiosDX();
            if (municipios) {
                setMunicipios(municipios);
                await saveMunicipiosDX(municipios); // Save the result to IndexedDB
            }
        }
    }
    async function fetchMunicipiosDX() {
        const url = '/diagnostico/obtenermunicipiosdx';
        return apiService.get(url, token)
            .then((response) => {
                if (Array.isArray(response.data.municipiosdx)) {
                    return response.data.municipiosdx;   
                }
                return null;
            })
            .catch((error) => {
                console.error('Error fetching municipios:', error);
                return null;
            });
    }
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };
    function setTipoMovilidad(departamento, municipio) {
        if (departamento !== '2') {
            setValue('vict_4_4_6_tipo_movilidad', '1');
        }else if (departamento === '2') {
            if (municipio !== '12') {
                setValue('vict_4_4_6_tipo_movilidad', '2');
            } else if (municipio === '12') {
                setValue('vict_4_4_6_tipo_movilidad', '3');
            }
        }
    }
    
    function setResultOrError(result, key, setter) {
        if (result[key]) {
            setter(result[key]);
        } else {
            Mensaje('Error', result.data?.message || `Fallo al cargar ${key}`, 'error');
        }
    }
    useEffect(() => {
        if (pendingResetData && municipios.length > 0) {
            FormReset(pendingResetData);
            
            if (pendingResetData?.vict_4_4_2_municipio) {
                const departementoId = municipios.find((municipio) => municipio.id === pendingResetData.vict_4_4_2_municipio?.toString())?.mun_departamentoid;
                setValue('vict_4_4_1_departamento', departementoId?.toString() || '');
                const municipiosNuevo = municipios
                    .filter((municipio) => municipio.mun_departamentoid === departementoId.toString())
                    .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }))
                setMunicipiosExpulsor(municipiosNuevo);
                setTimeout(() => {
                    setValue('vict_4_4_2_municipio', pendingResetData.vict_4_4_2_municipio?.toString() || '');
                    setTipoMovilidad(departementoId, pendingResetData.vict_4_4_2_municipio?.toString());
                }, 0);
            } else {
                setMunicipiosExpulsor([]);
            }
            setPendingResetData(null);
        }
    }, [pendingResetData, municipios]);
    const InicializarFormulario = async () => {
        const url = '/diagnostico/crearformulariovictimizacion';
        const obj = { iddx: iddx, idrecepcion: idrecepcion };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setFechaInicioAtencion(result.fechahoraatencion || null);
            setEstadoDx(result.estadodx);
            setResultOrError(result, 'actoresarmados', setActoresarmados);
            setResultOrError(result, 'enfoquegeneros', setEnfoquegeneros);
            setResultOrError(result, 'comunas', setComunas);
            setResultOrError(result, 'barrios', setBarrios);
            setResultOrError(result, 'entidadesdeclaracion', setEntidadesdeclaracion);
            setResultOrError(result, 'tiposdesplazamiento', setTiposdesplazamiento);
            setResultOrError(result, 'lugaresexpulsores', setLugaresexpulsores);
            setResultOrError(result, 'tiposmovilidades', setTiposmovilidades);

            setCualeshechos(hechos);
            setCualeshechosdeclarados(hechos);

            if (result.victimizacion) {
                setPendingResetData(result.victimizacion);
            } else {
                Mensaje('Error', result.data?.message || 'Fallo al cargar victimizacion', 'error');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
   
    const FormReset = (data) => {
        if (!data) return;
        if (data?.vict_4_6_2_cual) {
            const hechos = data.vict_4_6_2_cual.split(',');
            const cualesSeleccionadas = cualeshechos.filter((hecho) => hechos.includes(hecho.value));
            setCualeshechosSeleccionadas(cualesSeleccionadas);
        }
        if (data?.vict_4_6_3_declaro_este_hecho_victimizante) {
            const hechosdeclarados = data.vict_4_6_3_declaro_este_hecho_victimizante.split(',');
            const cualesdeclaradosSeleccionadas = cualeshechosdeclarados.filter((hecho) => hechosdeclarados.includes(hecho.value));
            setCualeshechosdeclaradosSeleccionadas(cualesdeclaradosSeleccionadas);
        }
        if (data) {
            data.vict_4_5_fecha_hecho = moment(data?.vict_4_5_fecha_hecho?.split('T')[0], 'YYYY-MM-DD', true).isValid()
                ? moment.utc(data?.vict_4_5_fecha_hecho).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
        }
        reset((prevValues) => ({
            ...prevValues,
            iddx: data?.iddx || '',
            vict_4_1_1_desaparicion_forzada: data?.vict_4_1_1_desaparicion_forzada || false,
            vict_4_1_2_secuestro: data?.vict_4_1_2_secuestro || false,
            vict_4_1_3_desplazamiento_forzado: data?.vict_4_1_3_desplazamiento_forzado || false,
            vict_4_1_4_homicidio: data?.vict_4_1_4_homicidio || false,
            vict_4_1_5_masacre: data?.vict_4_1_5_masacre || false,
            vict_4_1_6_tortura_o_tratos_inhumanos_degradantes: data?.vict_4_1_6_tortura_o_tratos_inhumanos_degradantes || false,
            vict_4_1_7_lesiones_permanentes_o_transitorias: data?.vict_4_1_7_lesiones_permanentes_o_transitorias || false,
            vict_4_1_8_minas_antipersonal_municiones_sin_explotar: data?.vict_4_1_8_minas_antipersonal_municiones_sin_explotar || false,
            vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual: data?.vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual || false,
            vict_4_1_10_1_intento_de_reclutamiento: data?.vict_4_1_10_1_intento_de_reclutamiento || false,
            vict_4_1_10_2_reclutamiento_y_utilizacion: data?.vict_4_1_10_2_reclutamiento_y_utilizacion || false,
            vict_4_1_11_acto_terrorista: data?.vict_4_1_11_acto_terrorista || false,
            vict_4_1_12_amenaza: data?.vict_4_1_12_amenaza || false,
            vict_4_1_13_despojo_y_abandono_forzado_de_tierras: data?.vict_4_1_13_despojo_y_abandono_forzado_de_tierras || false,
            vict_4_1_14_a_m_donde_realizo_declaracion: data?.vict_4_1_14_a_m_donde_realizo_declaracion?.toString() || '',
            codigoFUD: data?.codigoFUD || '',
            vict_4_1_15_hecho_no_declarado: data?.vict_4_1_15_hecho_no_declarado || '',
            vict_4_1_15_1_hecho_no_declarado_cual: data?.vict_4_1_15_1_hecho_no_declarado_cual || '',
            vict_4_1_16_tipo_desplazamiento: data?.vict_4_1_16_tipo_desplazamiento?.toString() || '',
            vict_4_2_actor_armado_ocasiono_el_hecho_victimizante: data?.vict_4_2_actor_armado_ocasiono_el_hecho_victimizante?.toString() || '',
            vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante: data?.vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante?.toString() || '',
            vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar: data?.vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar || '',
            vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer: data?.vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer || '',
            vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad: data?.vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad || '',
            vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual: data?.vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual || '',
            vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad: data?.vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad || '',
            vict_4_3_3_1_identifico_violencia_basada_en_genero: data?.vict_4_3_3_1_identifico_violencia_basada_en_genero?.toString() || '',
            vict_4_3_3_2_identifico_violencia_basada_en_genero: data?.vict_4_3_3_2_identifico_violencia_basada_en_genero?.toString() || '',
            vict_4_3_3_3_identifico_violencia_basada_en_genero: data?.vict_4_3_3_3_identifico_violencia_basada_en_genero?.toString() || '',
            vict_4_4_1_departamento: data?.vict_4_4_1_departamento?.toString() || '',
            vict_4_4_2_municipio: data?.vict_4_4_2_municipio?.toString() || '',
            vict_4_4_3_subregion_antioquia: data?.vict_4_4_3_subregion_antioquia || 'N/A',
            vict_4_4_4_lugar_exacto_del_municipio: data?.vict_4_4_4_lugar_exacto_del_municipio || '',
            vict_4_4_5_nombre_tipo_entorno: data?.vict_4_4_5_nombre_tipo_entorno || '',
            vict_4_4_6_tipo_movilidad: data?.vict_4_4_6_tipo_movilidad || '',
            vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento: data?.vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento?.toString() || '',
            vict_4_4_8_hecho_intraurbano_barrio: data?.vict_4_4_8_hecho_intraurbano_barrio?.toString() || '',
            vict_4_4_9_hecho_intraurbano_sector_o_asentamiento: data?.vict_4_4_9_hecho_intraurbano_sector_o_asentamiento || '',
            vict_4_4_10_hecho_intraurbano_direccion: data?.vict_4_4_10_hecho_intraurbano_direccion || '',
            vict_4_5_fecha_hecho: data?.vict_4_5_fecha_hecho || '',
            vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho: data?.vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho || '',
            vict_4_6_2_cual: data?.vict_4_6_2_cual || '',
            vict_4_6_3_declaro_este_hecho_victimizante: data?.vict_4_6_3_declaro_este_hecho_victimizante || '',
            vict_4_7_observaciones: data?.vict_4_7_observaciones || '',
            
        }));
        
    };  
    function irADerechos(){
        if (estadoDx >= 6)
        Navigate(`/dx/derechos/${iddx}/${idrecepcion}`);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/diagnostico/guardarvictimizacion';
        try {
            data.vict_4_4_3_subregion_antioquia = municipios.find(mun => mun.id === data.vict_4_4_2_municipio)?.mun_subregion || 'N/A';
            data.vict_4_5_fecha_hecho = (moment(data.vict_4_5_fecha_hecho).isValid()) ? moment(data.vict_4_5_fecha_hecho).format('YYYY-MM-DD') : null;
            if (data) {
            data.vict_4_6_2_cual = cualeshechosSeleccionadas.map(opt => opt.value).join(',');
            }
            if (data) {
                data.vict_4_6_3_declaro_este_hecho_victimizante = cualeshechosdeclaradosSeleccionadas.map(opt => opt.value).join(',');
            }
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                setEstadoDx(response.data.estadodx);
                Mensaje('Guardar', JSON.stringify(response.data.message), 'success');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
            }else{
                Mensaje('Guardar', `Error al guardar los datos: ${error}`, 'error');
                console.error('Error fetching data:', error);
            }
        } finally {
            setCargando(false);
        }
    }; 
    useEffect(() => {
        getMunicipiosDXData();
    }, []);
    useEffect(() => {
        if (municipios.length > 0) {
            setDepartamentosExpulsor([
                ...new Map(
                    municipios.map((municipio) => [
                        municipio.mun_departamentoid,
                        { id: municipio.mun_departamentoid, name: municipio.mun_departamento },
                    ])
                ).values(),
            ]);
            InicializarFormulario();
        }
    }, [municipios])  
    return (
        
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Victimización"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Victimización"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={estadoDx} />
                <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={5} estadoDx={estadoDx}/>
                <div id="formDiagnostico" className="card">
                    <div className="row">
                    <div className="col-md-12">
                        <div className="nav-tabs-custom">
                        <div className="tab-content">
                            <h4>4. VICTIMIZACION</h4>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title"><b>4.1. Hecho o Hechos Victimizante</b></h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="row" >
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('vict_4_1_1_desaparicion_forzada')}
                                                    onChange={(e) => {
                                                        setValue("vict_4_1_1_desaparicion_forzada", e.target.checked)
                                                    }}
                                                    className="custom-control-input" id="vict_4_1_1_desaparicion_forzada"
                                                    disabled/>
                                                <label className="custom-control-label" htmlFor="vict_4_1_1_desaparicion_forzada"> 4.1.1. Desaparici&oacute;n forzada</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_2_secuestro')}
                                                        onChange={e => setValue('vict_4_1_2_secuestro', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_2_secuestro"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_2_secuestro">
                                                        4.1.2. Secuestro
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_3_desplazamiento_forzado')}
                                                        onChange={e => setValue('vict_4_1_3_desplazamiento_forzado', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_3_desplazamiento_forzado"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_3_desplazamiento_forzado">
                                                        4.1.3. Desplazamiento forzado
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_4_homicidio')}
                                                        onChange={e => setValue('vict_4_1_4_homicidio', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_4_homicidio"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_4_homicidio">
                                                        4.1.4. Homicidio
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_5_masacre')}
                                                        onChange={e => setValue('vict_4_1_5_masacre', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_5_masacre"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_5_masacre">
                                                        4.1.5. Masacre
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_6_tortura_o_tratos_inhumanos_degradantes')}
                                                        onChange={e => setValue('vict_4_1_6_tortura_o_tratos_inhumanos_degradantes', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_6_tortura_o_tratos_inhumanos_degradantes"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_6_tortura_o_tratos_inhumanos_degradantes">
                                                        4.1.6. Tortura o tratos inhumanos degradantes
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_7_lesiones_permanentes_o_transitorias')}
                                                        onChange={e => setValue('vict_4_1_7_lesiones_permanentes_o_transitorias', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_7_lesiones_permanentes_o_transitorias"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_7_lesiones_permanentes_o_transitorias">
                                                        4.1.7. Lesiones Personales Permanentes o Transitorias
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_8_minas_antipersonal_municiones_sin_explotar')}
                                                        onChange={e => setValue('vict_4_1_8_minas_antipersonal_municiones_sin_explotar', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_8_minas_antipersonal_municiones_sin_explotar"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_8_minas_antipersonal_municiones_sin_explotar">
                                                        4.1.8. Minas antipersonal, Municiones sin Explotar, y Artefacto Explosivo improvisado
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual')}
                                                        onChange={e => setValue('vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual">
                                                        4.1.9. Delitos contra la libertad y la integridad sexual
                                                    </label>
                                                </div>
                                            </div>
                                        </div>                  
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_10_1_intento_de_reclutamiento')}
                                                        onChange={e => setValue('vict_4_1_10_1_intento_de_reclutamiento', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_10_1_intento_de_reclutamiento"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_10_1_intento_de_reclutamiento">
                                                        4.1.10.1. Intento de Reclutamiento
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_10_2_reclutamiento_y_utilizacion')}
                                                        onChange={e => setValue('vict_4_1_10_2_reclutamiento_y_utilizacion', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_10_2_reclutamiento_y_utilizacion"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_10_2_reclutamiento_y_utilizacion">
                                                        4.1.10.2. Reclutamiento y utilizaci&oacute;n
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_11_acto_terrorista')}
                                                        onChange={e => setValue('vict_4_1_11_acto_terrorista', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_11_acto_terrorista"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_11_acto_terrorista">
                                                        4.1.11. Acto terrorista/Atentados/Combates/Enfrentamientos/Hostigamientos
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_12_amenaza')}
                                                        onChange={e => setValue('vict_4_1_12_amenaza', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_12_amenaza"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_12_amenaza">
                                                        4.1.12. Amenaza
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_13_despojo_y_abandono_forzado_de_tierras')}
                                                        onChange={e => setValue('vict_4_1_13_despojo_y_abandono_forzado_de_tierras', e.target.checked)}
                                                        className="custom-control-input"
                                                        id="vict_4_1_13_despojo_y_abandono_forzado_de_tierras"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_13_despojo_y_abandono_forzado_de_tierras">
                                                        4.1.13. Despojo y abandono forzado de tierras
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-8">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_1_14_a_m_donde_realizo_declaracion'>4.1.14. Agencia del Ministerio P&uacute;blico donde realiz&oacute; la declaraci&oacute;n del(os) Hecho(s) Victimizante (s)</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_1_14_a_m_donde_realizo_declaracion"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_1_14_a_m_donde_realizo_declaracion', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_1_14_a_m_donde_realizo_declaracion')}
                                                onChange={e => setValue('vict_4_1_14_a_m_donde_realizo_declaracion', e.target.value)}
                                                onBlur={(() => {
                                                    document.getElementById('infoslcvict_4_1_14_a_m_donde_realizo_declaracion').hidden = true;
                                                })}
                                                onFocus={(() => {
                                                    document.getElementById('infoslcvict_4_1_14_a_m_donde_realizo_declaracion').hidden = false;
                                                })}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {entidadesdeclaracion.map(entidad => (
                                                    <option key={entidad.id} value={entidad.id}>
                                                        {entidad.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_1_14_a_m_donde_realizo_declaracion && <span className="text-danger">{errors.vict_4_1_14_a_m_donde_realizo_declaracion.message}</span>}
                                            <span hidden id="infoslcvict_4_1_14_a_m_donde_realizo_declaracion"> Indicar Agencia donde se realiz&oacute; la declaraci&oacute;n del(os) Hechos Victimizantes.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                            <label htmlFor='txtcodFUD'>C&oacute;digo FUD</label>
                                            <input
                                                maxLength="20"
                                                id="txtcodFUD"
                                                type="text"
                                                className="form-control"
                                                placeholder="FUD"
                                                {...register('codigoFUD', { required: "Este campo es obligatorio" })}
                                                value={watch('codigoFUD')}
                                                onChange={e => setValue('codigoFUD', e.target.value.toUpperCase())}
                                                onBlur={() => { document.getElementById('infoFud').hidden = true; }}
                                                onFocus={() => { document.getElementById('infoFud').hidden = false; }}
                                            /> 
                                            {errors.codigoFUD && <span className="text-danger">{errors.codigoFUD.message}</span>}
                                            <span hidden id="infoFud">Sino sabe el codigo FUD, escribir Sin dato</span>
                                            </div>                 
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('vict_4_1_15_hecho_no_declarado')}
                                                        onChange={e => {
                                                            setValue('vict_4_1_15_hecho_no_declarado', e.target.checked)
                                                            if(!e.target.checked) {
                                                                setValue('vict_4_1_15_1_hecho_no_declarado_cual', '')
                                                            }
                                                            
                                                        }}
                                                        className="custom-control-input"
                                                        id="vict_4_1_15_hecho_no_declarado"
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_1_15_hecho_no_declarado">
                                                        4.1.15. ¿Existe alg&uacute;n Hecho Victimizante no declarado ante Ministerio P&uacute;blico?
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_1_15_1_hecho_no_declarado_cual'>4.1.15.1 ¿Cu&aacute;les?</label>
                                            <input
                                                id="txtvict_4_1_15_1_hecho_no_declarado_cual"
                                                type="text"
                                                className="form-control"
                                                placeholder="¿Cuál?"
                                                maxLength={255}
                                                {...register('vict_4_1_15_1_hecho_no_declarado_cual', { required: watch('vict_4_1_15_hecho_no_declarado') ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_1_15_1_hecho_no_declarado_cual')}
                                                onChange={e => setValue('vict_4_1_15_1_hecho_no_declarado_cual', e.target.value.toUpperCase())}
                                                disabled={!watch('vict_4_1_15_hecho_no_declarado')}
                                            />
                                            {errors.vict_4_1_15_1_hecho_no_declarado_cual && <span className="text-danger">{errors.vict_4_1_15_1_hecho_no_declarado_cual.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_1_16_tipo_desplazamiento'>4.1.16. Tipo de desplazamiento</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_1_16_tipo_desplazamiento"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_1_16_tipo_desplazamiento', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_1_16_tipo_desplazamiento')}
                                                onChange={e => setValue('vict_4_1_16_tipo_desplazamiento', e.target.value)}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {tiposdesplazamiento.map(tipo => (
                                                    <option key={tipo.id} value={tipo.id}>
                                                        {tipo.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_1_16_tipo_desplazamiento && <span className="text-danger">{errors.vict_4_1_16_tipo_desplazamiento.message}</span>}
                                            </div>
                                        </div>
                                        </div>                    
                                        <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_2_actor_armado_ocasiono_el_hecho_victimizante'>4.2. ¿Qu&eacute; actor armado ocasion&oacute; el hecho victimizante?</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_2_actor_armado_ocasiono_el_hecho_victimizante"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante')}
                                                onChange={e => {
                                                    setValue('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante', e.target.value)
                                                    if(e.target.value === "")
                                                        setValue('vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante', '')
                                                    if(e.target.value !== "71")
                                                        setValue('vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar', '')
                                                }}
                                                onBlur={() => { document.getElementById('infoslcvict_4_2_actor_armado_ocasiono_el_hecho_victimizante').hidden = true; }}
                                                onFocus={() => { document.getElementById('infoslcvict_4_2_actor_armado_ocasiono_el_hecho_victimizante').hidden = false; }}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {actoresarmados.map(actor => (
                                                    <option key={actor.id} value={actor.id}>
                                                        {actor.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_2_actor_armado_ocasiono_el_hecho_victimizante && <span className="text-danger">{errors.vict_4_2_actor_armado_ocasiono_el_hecho_victimizante.message}</span>}
                                            <span hidden id="infoslcvict_4_2_actor_armado_ocasiono_el_hecho_victimizante"> Seleccione el nombre del actor responsable del hecho victimizante tal como la persona lo informa.</span>
                                            </div>
                                        </div>
                                        </div>
                                        <div id="div_4_2_1_actor_armado" className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante'>4.2.1 ¿Qu&eacute; actor armado ocasion&oacute; el hecho victimizante?</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante')}
                                                value={watch('vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante')}
                                                onChange={e => {
                                                    setValue('vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante', e.target.value)
                                                }}
                                                onBlur={() => { document.getElementById('infoslcvict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante').hidden = true; }}
                                                onFocus={() => { document.getElementById('infoslcvict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante').hidden = false; }}
                                                disabled={watch('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante') === ""}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {actoresarmados.map(actor => (
                                                    <option key={actor.id} value={actor.id}>
                                                        {actor.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            <span hidden id="infoslcvict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante">Seleccione el nombre del actor responsable del hecho victimizante tal como la persona lo informa.</span>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_2_1_1_Si_la_Respuesta_anterior_es_OTROS_cual_Identificar'>4.2.1.1 Si la Respuesta anterior es OTROS ¿cual? Identificar</label>
                                            <input
                                                id="txtvict_4_2_1_1_Si_la_Respuesta_anterior_es_OTROS_cual_Identificar"
                                                maxLength="1020"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cual"
                                                {...register('vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar', { required: watch('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante') === "71" ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar')}
                                                onChange={e => setValue('vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar', e.target.value.toUpperCase())}
                                                disabled={watch('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante') === "" || watch('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante') !== "71"}
                                            />
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-title">
                                        <h5><b>4.3. Enfoque de G&eacute;nero</b></h5>
                                        </div>
                                        <div className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer"
                                                        {...register('vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer')}
                                                        checked={!!watch('vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer')}
                                                        onChange={e => {
                                                            setValue('vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer', e.target.checked)
                                                            if(!e.target.checked) {
                                                                setValue('vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad', '')
                                                            }
                                                        }}
                                                        onBlur={() => { document.getElementById('infochkvict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer').hidden = true; }}
                                                        onFocus={() => { document.getElementById('infochkvict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer').hidden = false; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer">
                                                        4.3.1. ¿El hecho victimizante tiene que ver con la condici&oacute;n de ser mujer de alguna integrante del hogar?
                                                    </label>
                                                    <span hidden id="infochkvict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer">
                                                        Violencia basada en g&eacute;nero.
                                                    </span>
                                                </div>
                                            </div>
                                        </div> 
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_3_1_1_Relacion_con_el_jefea_de_hogar_y_edad'>4.3.1.1. Relaci&oacute;n con el jefe(a) de hogar y edad</label>
                                            <input
                                                id="txtvict_4_3_1_1_Relacion_con_el_jefea_de_hogar_y_edad"
                                                type="text"
                                                maxLength="1020"
                                                className="form-control"
                                                placeholder="Relación"
                                                {...register('vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad', { required: watch('vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer') ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad')}
                                                onChange={e => setValue('vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad', e.target.value.toUpperCase())}
                                                onBlur={() => { document.getElementById('infotxtvict_4_3_1_1_Relacion_con_el_jefea_de_hogar_y_edad').hidden = true; }}
                                                onFocus={() => { document.getElementById('infotxtvict_4_3_1_1_Relacion_con_el_jefea_de_hogar_y_edad').hidden = false; }}
                                                disabled={!watch('vict_4_3_1_hecho_tiene_que_ver_con_condicion_de_ser_mujer')}
                                            />
                                            {errors.vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad && <span className="text-danger">{errors.vict_4_3_1_1_relacion_con_el_jefea_de_hogar_y_edad.message}</span>}
                                            <span hidden id="infotxtvict_4_3_1_1_Relacion_con_el_jefea_de_hogar_y_edad">Si la respuesta anterior es seleccionada, escriba la relacion con el jefe de hogar y edad.</span>
                                            </div>
                                        </div>                 
                                        </div>
                                        <div className="row">  
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual"
                                                        {...register('vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual')}
                                                        checked={!!watch('vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual')}
                                                        onChange={e => {
                                                            setValue('vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual', e.target.checked)
                                                            if(!e.target.checked) {
                                                                setValue('vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad', '')
                                                            }
                                                        }}
                                                        onBlur={() => { document.getElementById('infochkvict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual').hidden = true; }}
                                                        onFocus={() => { document.getElementById('infochkvict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual').hidden = false; }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual">
                                                        4.3.2. ¿El hecho victimizante tiene que ver con la condici&oacute;n sexual de alg&uacute;n integrante del n&uacute;cleo familiar?
                                                    </label>
                                                    <span hidden id="infochkvict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual">
                                                        Violencia basada en genero.
                                                    </span>
                                                </div>
                                            </div>
                                        </div> 
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad'>4.3.2.1. Relaci&oacute;n con el jefe(a) de hogar y edad</label>
                                            <input
                                                id="txtvict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad"
                                                type="text"
                                                maxLength="1020"
                                                className="form-control"
                                                placeholder="Relación"
                                                {...register('vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad', { required: watch('vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual') ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad')}
                                                onChange={e => setValue('vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad', e.target.value.toUpperCase())}
                                                onBlur={() => { document.getElementById('infotxtvict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad').hidden = true; }}
                                                onFocus={() => { document.getElementById('infotxtvict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad').hidden = false; }}
                                                disabled={!watch('vict_4_3_2_hecho_tiene_que_ver_con_condicion_sexual')}
                                            />
                                            {errors.vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad && <span className="text-danger">{errors.vict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad.message}</span>}
                                            <span hidden id="infotxtvict_4_3_2_1_relacion_con_el_jefe_de_hogar_y_edad">Si la respuesta anterior es seleccionada, escriba la relacion con el jefe de hogar y edad.</span>
                                            </div>
                                        </div>        
                                        </div>
                                        <div className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_3_3_1_identifico_violencia_basada_en_genero'>4.3.3.1. Identific&oacute; alguna(s) de las siguientes violencia basada en g&eacute;nero en el marco del conflicto armado? </label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_3_3_1_identifico_violencia_basada_en_genero"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_3_3_1_identifico_violencia_basada_en_genero', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_3_3_1_identifico_violencia_basada_en_genero')}
                                                onChange={e => {
                                                    setValue('vict_4_3_3_1_identifico_violencia_basada_en_genero', e.target.value)
                                                    if(e.target.value === "" || e.target.value === "0"){
                                                        setValue('vict_4_3_3_2_identifico_violencia_basada_en_genero', '')
                                                        setValue('vict_4_3_3_3_identifico_violencia_basada_en_genero', '')
                                                    }

                                                }}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {enfoquegeneros.map(enfoque => (
                                                    <option key={enfoque.id} value={enfoque.id}>
                                                        {enfoque.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_3_3_1_identifico_violencia_basada_en_genero && <span className="text-danger">{errors.vict_4_3_3_1_identifico_violencia_basada_en_genero.message}</span>}
                                            </div>
                                        </div>        
                                        </div>
                                        <div id="divViolenciaGenero2" className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_3_3_2_identifico_violencia_basada_en_genero'>4.3.3.2. Identific&oacute; alguna(s) de las siguientes violencia basada en g&eacute;nero en el marco del conflicto armado? </label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_3_3_2_identifico_violencia_basada_en_genero"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_3_3_2_identifico_violencia_basada_en_genero')}
                                                value={watch('vict_4_3_3_2_identifico_violencia_basada_en_genero')}
                                                onChange={e => {
                                                    setValue('vict_4_3_3_2_identifico_violencia_basada_en_genero', e.target.value)
                                                    if(e.target.value === "" || e.target.value === "0"){
                                                        setValue('vict_4_3_3_3_identifico_violencia_basada_en_genero', '')
                                                    }
                                                }}
                                                disabled={watch('vict_4_3_3_1_identifico_violencia_basada_en_genero') === "" || watch('vict_4_3_3_1_identifico_violencia_basada_en_genero') === "0"}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {enfoquegeneros.map(enfoque => (
                                                    <option key={enfoque.id} value={enfoque.id}>
                                                        {enfoque.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            </div>
                                        </div>        
                                        </div>
                                        <div id="divViolenciaGenero3" className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_3_3_3_identifico_violencia_basada_en_genero'>4.3.3.3 Identific&oacute; alguna(s) de las siguientes violencia basada en g&eacute;nero en el marco del conflicto armado? </label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_3_3_3_identifico_violencia_basada_en_genero"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_3_3_3_identifico_violencia_basada_en_genero')}
                                                value={watch('vict_4_3_3_3_identifico_violencia_basada_en_genero')}
                                                onChange={e => setValue('vict_4_3_3_3_identifico_violencia_basada_en_genero', e.target.value)}
                                                disabled={watch('vict_4_3_3_2_identifico_violencia_basada_en_genero') === "" || watch('vict_4_3_3_2_identifico_violencia_basada_en_genero') === "0"}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {enfoquegeneros.map(enfoque => (
                                                    <option key={enfoque.id} value={enfoque.id}>
                                                        {enfoque.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card-title">
                                        <h5><b>4.4. Lugar donde ocurri&oacute; el Hecho Victimizante</b></h5>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_4_1_departamento'>4.4.1. Departamento</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_4_1_departamento"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_4_1_departamento', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_4_1_departamento')}
                                                onChange={e => {                                                    
                                                    setValue('vict_4_4_1_departamento', e.target.value)
                                                    setValue('vict_4_4_2_municipio', '')
                                                    setValue('vict_4_4_3_subregion_antioquia', 'N/A')
                                                    if (e.target.value) {
                                                        setMunicipiosExpulsor(
                                                            municipios.filter((municipio) => municipio.mun_departamentoid === e.target.value)
                                                            .map((municipio) => ({ id: municipio.id, name: municipio.mun_municipio }))
                                                        );
                                                    }
                                                    setTipoMovilidad(e.target.value, watch('vict_4_4_2_municipio'))
                                                }}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {departamentosExpulsor.map(dep => (
                                                    <option key={dep.id} value={dep.id}>
                                                        {dep.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_4_1_departamento && <span className="text-danger">{errors.vict_4_4_1_departamento.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_4_2_municipio'>4.4.2. Municipio</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_4_2_municipio"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_4_2_municipio', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_4_2_municipio')}
                                                onChange={e => {
                                                    setValue('vict_4_4_2_municipio', e.target.value)
                                                    setValue('vict_4_4_3_subregion_antioquia', municipios.find(mun => mun.id === e.target.value).mun_subregion);
                                                    setTipoMovilidad(watch('vict_4_4_1_departamento'), e.target.value)
                                                    if(e.target.value !== "12") {
                                                        setValue('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento', '')
                                                        setValue('vict_4_4_8_hecho_intraurbano_barrio', '')
                                                        setValue('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento', '')
                                                        setValue('vict_4_4_10_hecho_intraurbano_direccion', '')
                                                    }else {
                                                        setValue('vict_4_4_4_lugar_exacto_del_municipio', '')
                                                        setValue('vict_4_4_5_nombre_tipo_entorno', '')
                                                    }
                                                }}
                                                onBlur={() => { document.getElementById('infoslcvict_4_4_2_municipio').hidden = true; }}
                                                onFocus={() => { document.getElementById('infoslcvict_4_4_2_municipio').hidden = false; }}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {municipiosExpulsor.map(mun => (
                                                    <option key={mun.id} value={mun.id}>
                                                        {mun.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_4_2_municipio && <span className="text-danger">{errors.vict_4_4_2_municipio.message}</span>}
                                            <span hidden id="infoslcvict_4_4_2_municipio">Seleccionar el Municipio donde ocurrio el hecho victimizante.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_4_3_subregion_antioquia'>4.4.3. Subregion de Antioquia</label>
                                            <input
                                                id="txtvict_4_4_3_subregion_antioquia"
                                                type="text"
                                                maxLength="120"
                                                className="form-control"
                                                placeholder="subregion"
                                                {...register('vict_4_4_3_subregion_antioquia')}
                                                value={watch('vict_4_4_3_subregion_antioquia')}
                                                onChange={e => setValue('vict_4_4_3_subregion_antioquia', e.target.value.toUpperCase())}
                                                onBlur={() => { document.getElementById('infoslcvict_4_4_3_subregion_antioquia').hidden = true; }}
                                                onFocus={() => { document.getElementById('infoslcvict_4_4_3_subregion_antioquia').hidden = false; }}
                                                disabled
                                            />
                                            <span hidden="infoslcvict_4_4_3_subregion_antioquia">Muestra la Subregion de Antioquia a la que pertenece.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_4_4_lugar_exacto_del_municipio'>4.4.4. ¿En qu&eacute; lugar exacto del municipio ocurrieron los hechos?</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_4_4_lugar_exacto_del_municipio"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_4_4_lugar_exacto_del_municipio', { required: watch('vict_4_4_2_municipio') !== '12' ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_4_4_lugar_exacto_del_municipio')}
                                                onChange={e => setValue('vict_4_4_4_lugar_exacto_del_municipio', e.target.value)}
                                                disabled={watch('vict_4_4_2_municipio') === '12'}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {lugaresexpulsores.map(lugar => (
                                                    <option key={lugar.id} value={lugar.id}>
                                                        {lugar.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_4_4_lugar_exacto_del_municipio && <span className="text-danger">{errors.vict_4_4_4_lugar_exacto_del_municipio.message}</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_4_5_nombre_tipo_entorno'>4.4.5. Nombre del Tipo de Entorno</label>
                                            <input
                                                id="txtvict_4_4_5_nombre_tipo_entorno"
                                                type="text"
                                                maxLength="120"
                                                className="form-control"
                                                placeholder="Entorno"
                                                {...register('vict_4_4_5_nombre_tipo_entorno', { required: watch('vict_4_4_2_municipio') !== '12' ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_4_5_nombre_tipo_entorno')}
                                                onChange={e => setValue('vict_4_4_5_nombre_tipo_entorno', e.target.value.toUpperCase())}
                                                onBlur={() => { document.getElementById('infotxtvict_4_4_5_nombre_tipo_entorno').hidden = true; }}
                                                onFocus={() => { document.getElementById('infotxtvict_4_4_5_nombre_tipo_entorno').hidden = false; }}
                                                disabled={watch('vict_4_4_2_municipio') === '12'}
                                            />
                                            {errors.vict_4_4_5_nombre_tipo_entorno && <span className="text-danger">{errors.vict_4_4_5_nombre_tipo_entorno.message}</span>}
                                            <span hidden id="infotxtvict_4_4_5_nombre_tipo_entorno">Nombre del barrio, vereda, o corregimiento donde ocurrio el hecho victimizante. (Si es cabecera municipal se coloca el nombre del municipio).</span>
                                            </div>  
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_4_6_tipo_movilidad'>4.4.6. Tipo de movilidad</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_4_6_tipo_movilidad"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_4_6_tipo_movilidad', { required: "Este campo es obligatorio" })}
                                                value={watch('vict_4_4_6_tipo_movilidad')}
                                                onChange={e => setValue('vict_4_4_6_tipo_movilidad', e.target.value)}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {tiposmovilidades.map(tipo => (
                                                    <option key={tipo.id} value={tipo.id}>
                                                        {tipo.nombre}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.vict_4_4_6_tipo_movilidad && <span className="text-danger">{errors.vict_4_4_6_tipo_movilidad.message}</span>}
                                            </div>
                                        </div>
                                        </div>
                                        <div className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_4_7_hecho_Intraurbano_Comuna_o_Corregimiento'>4.4.7. En caso de ser un hecho victimizante Intraurbano ¿En qu&eacute; Comuna o Corregimiento sucedi&oacute; el Hecho Victimizante?</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_4_7_hecho_Intraurbano_Comuna_o_Corregimiento"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento', { required: watch('vict_4_4_2_municipio') === '12' ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento')}
                                                onChange={e => setValue('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento', e.target.value)}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {comunas.map(comuna => (
                                                    <option key={comuna.id} value={comuna.id}>
                                                        {comuna.comuna}
                                                    </option>
                                                ))}
                                            </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcvict_4_4_8_hecho_Intraurbano_Barrio'>4.4.8. En caso de ser un hecho victimizante Intraurbano ¿En qu&eacute; Barrio sucedi&oacute; el Hecho Victimizante?</label>
                                            <select
                                                className="form-control"
                                                id="slcvict_4_4_8_hecho_Intraurbano_Barrio"
                                                style={{ width: "100%" }}
                                                {...register('vict_4_4_8_hecho_intraurbano_barrio', { required: watch('vict_4_4_2_municipio') === '12' ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_4_8_hecho_intraurbano_barrio')}
                                                onChange={e => {
                                                    setValue('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento', barrios.find(barrio => barrio.id === e.target.value)?.idcomuna || '');
                                                    setValue('vict_4_4_8_hecho_intraurbano_barrio', e.target.value)
                                                }}
                                                disabled={watch('vict_4_4_2_municipio') !== '12'}
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                {barrios.map(barrio => (
                                                    <option key={barrio.id} value={barrio.id}>
                                                        {barrio.barrio}
                                                    </option>
                                                ))}
                                            </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_4_9_hecho_Intraurbano_Sector_o_Asentamiento'>4.4.9. En caso de ser un hecho victimizante Intraurbano ¿En qu&eacute; Sector o Asentamiento sucedi&oacute; el Hecho Victimizante?</label>
                                            <input
                                                id="txtvict_4_4_9_hecho_Intraurbano_Sector_o_Asentamiento"
                                                type="text"
                                                maxLength="120"
                                                className="form-control"
                                                placeholder="Sector"
                                                {...register('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento', { required: watch('vict_4_4_2_municipio') === '12' ? "Este campo es obligatorio" : false })}
                                                value={watch('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento')}
                                                onChange={e => setValue('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento', e.target.value.toUpperCase())}
                                                disabled={watch('vict_4_4_2_municipio') !== '12'}
                                            />
                                            {errors.vict_4_4_9_hecho_intraurbano_sector_o_asentamiento && <p style={{color: 'red'}}>Digite el sector o asentamiento</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='txtvict_4_4_10_hecho_Intraurbano_Direccion'>4.4.10. En caso de ser un hecho victimizante Intraurbano ingrese la Direcci&oacute;n donde ocurri&oacute;</label>
                                            <input
                                                id="txtvict_4_4_10_hecho_Intraurbano_Direccion"
                                                type="text"
                                                maxLength="120"
                                                className="form-control"
                                                placeholder="Ej. CL 10 A SUR 35 25 APTO 305"
                                                {...register('vict_4_4_10_hecho_intraurbano_direccion', { 
                                                        required: watch('vict_4_4_2_municipio') === '12' ? "Este campo es obligatorio" : false
                                                })}
                                                value={watch('vict_4_4_10_hecho_intraurbano_direccion')}
                                                onChange={e => setValue('vict_4_4_10_hecho_intraurbano_direccion', e.target.value.toUpperCase())}
                                                onFocus={() => { document.getElementById('infotxtvict_4_4_10_hecho_Intraurbano_Direccion').hidden = false; }}
                                                onBlur={(e) => { 
                                                    e.target.value = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '').toUpperCase();
                                                    document.getElementById('infotxtvict_4_4_10_hecho_Intraurbano_Direccion').hidden = true; 
                                                }}
                                                disabled={watch('vict_4_4_2_municipio') !== '12'}
                                            />
                                            </div>
                                            {errors.vict_4_4_10_hecho_intraurbano_direccion && <p style={{color: 'red'}}>{errors.vict_4_4_10_hecho_intraurbano_direccion.message}</p>}
                                            <span hidden id="infotxtvict_4_4_10_hecho_Intraurbano_Direccion">Digitar la Direccion. Es fundamental que se coloque alguna direccion.</span>
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor='vict_4_5_fecha_hecho'>4.5 Fecha en la que ocurri&oacute; el Hecho Victimizante </label>
                                                <div className="input-group">
                                                    <Controller
                                                        control={control}
                                                        name="vict_4_5_fecha_hecho"
                                                        render={({ field }) => (
                                                            <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => {field.onChange(date);}}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value ? new Date(`${field.value}`) : null}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                maxDate={new Date()}
                                                                />
                                                            </div>
                                                        )}
                                                    />
                                                    {errors.vict_4_5_fecha_hecho && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                                </div>
                                            </div> 
                                        </div>
                                        </div>
                                        <div className="card-title">
                                        <h5><b>4.6. Revictimizaci&oacute;n</b></h5>
                                        </div>
                                        <div className="row" style={{backgroundColor : "aliceblue"}}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id="vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho"
                                                        {...register('vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho')}
                                                        checked={!!watch('vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho')}
                                                        onChange={e => {
                                                            setValue('vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho', e.target.checked)
                                                            if(!e.target.checked){
                                                                setCualeshechosSeleccionadas([])
                                                                setCualeshechosdeclaradosSeleccionadas([])
                                                            }
                                                        }}
                                                    />
                                                    <label className="custom-control-label" htmlFor="vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho">
                                                        4.6.1. ¿Usted o alg&uacute;n integrante de su familia ha sufrido con anterioridad alg&uacute;n otro hecho victimizante?
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                            </div>
                                        </div> 
                                        <div id="divotroHechoscual" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='vict_4_6_2_cual'>4.6.2. ¿Cu&aacute;l?</label>
                                            <Select
                                                id="vict_4_6_2_cual"
                                                value={cualeshechosSeleccionadas}
                                                isMulti
                                                name="vict_4_6_2_cual"
                                                options={cualeshechos}
                                                onChange={ActualizarCualesHechos}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                                isDisabled={!watch('vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho')}
                                            />
                                            {errors.vict_4_6_2_cual && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>
                                        <div id="divotroHechosdeclaro" className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='vict_4_6_3_declaro_este_hecho_victimizante'>4.6.3. ¿Declar&oacute; este hecho victimizante?</label>
                                            <Select
                                                id="vict_4_6_3_declaro_este_hecho_victimizante"
                                                value={cualeshechosdeclaradosSeleccionadas}
                                                isMulti
                                                name="vict_4_6_3_declaro_este_hecho_victimizante"
                                                options={cualeshechosdeclarados}
                                                onChange={ActualizarCualesHechosDeclarados}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                                isDisabled={!watch('vict_4_6_1_integrante_sufrio_con_anterioridad_otro_hecho')}
                                            />
                                            {errors.vict_4_6_3_declaro_este_hecho_victimizante && <p style={{ color: 'red' }}>Seleccione campos</p>}
                                            </div>
                                        </div>                 
                                        </div>
                                        <div className="row">
                                        <div className="col-md-12">
                                            <label htmlFor='txtvict_4_7_observaciones'>4.7. Observaciones del contexto</label>  
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">     
                                                <textarea
                                                    id="txtvict_4_7_observaciones"
                                                    maxLength="5000"
                                                    rows="5"
                                                    className="form-control"
                                                    placeholder="Observaciones"
                                                    {...register('vict_4_7_observaciones', { required: "Este campo es obligatorio",pattern: {
                                                        value: /^[A-Za-zÁÉÍÓÚáéíóúÑñ0-9 ,.]*$/,
                                                        message: "Solo se permiten letras, números, espacios, comas y puntos."
                                                    } })}
                                                    value={watch('vict_4_7_observaciones')}
                                                    onChange={e => {
                                                        const filtered = e.target.value.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ0-9 ,.]/g, '');
                                                        setValue('vict_4_7_observaciones', filtered.toUpperCase())
                                                    }}
                                                />
                                                {errors.vict_4_7_observaciones && <span className="text-danger">{errors.vict_4_7_observaciones.message}</span>}
                                            </div>
                                        </div>
                                        </div>

                                    </div>
                                    <div className='card-footer'>
                                        <div className="row">
                                            <div className="col-md-6">
                                            <button id="btnDxActualizarVictimizacion" type="submit" className="btn btn-block btn-primary btn-sm">Actualizar y seguir con Derechos
                                            </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </form>
                            
                            
                        </div>
                        </div>
                    </div>
                    </div>
                </div>     
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irADerechos();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
        
    )
  }